import { render, staticRenderFns } from "./Laboratorio.vue?vue&type=template&id=f372b580&scoped=true"
import script from "./Laboratorio.vue?vue&type=script&lang=js"
export * from "./Laboratorio.vue?vue&type=script&lang=js"
import style0 from "./Laboratorio.vue?vue&type=style&index=0&id=f372b580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f372b580",
  null
  
)

export default component.exports